import Icon, { IconProps } from './Icon'

export default Icon

export { Icon }
export type { IconProps }
